import DynamicForm from "components/DynamicForm";
import { validate } from "components/DynamicForm/validate";
import { handleEmailNotification, sendSMSInvite } from "helper/callbacks";
import { ButtonV1 } from "lib";
import React, { Fragment, useState } from "react";
import { Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { clearSelectedData, setSelectedData } from "redux/formDisplay";
import { dynamicFormScroll } from "utils";
import OTP from "lib/OTP" 
import { verifyOtp } from "api/otpVerification";
import Toast from "components/ToastComponent";
import { setVerificationResponse } from "redux/uploadDocumentReducer";

function InviteCustomer(props) {
  const { showModal, closeModal, setInviteToast,otp_verification_details,model_name,fieldName,autofill} = props;
  const [formErr, setFormErr] = useState({});
  const [button,setButton] = useState("Submit")
  const dispatch = useDispatch();
  const applicantUser = useSelector((state) => state.userInfo?.applicantUser);
  const primaryWorkflowId = useSelector((state) => state.userInfo.primaryUser._id)
  const tokenId = useSelector((state) => state.otpReducer.tokenId);
  const aadharOTPResponse = useSelector((state)=> state.otpReducer.aadharOTPResponse)
  const aadhaar_number = useSelector((state)=>state.otpReducer.otpValues.aadhaar_otp)
  const [messageToast, setMessageToast] = useState({ type: "", msg: "" });
  const aadhaarVerificationResponse = useSelector((state)=>state.otpReducer.otpResponse.aadhaar_otp)

  const currentSubWorkFlowId = useSelector(
    (state) => state?.dashboardDetailReducer?.currentSubWorkFlowId
  );
  const IndirectEval = (evalString) => {
    return eval(evalString);
  };
  const organisationIdOfUser = useSelector(
    (state) =>
      state?.loggedInUserInfo?.userAuthInfo?.profileInfo?.organisationId
  );
  const org_id = useSelector((state)=> state.loggedInUserInfo.organisation_id)
  const organisationInfo = useSelector((state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo)

  const { dashboardConfig } = useSelector((state) => state.dashboardReducer);
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const staticData = useSelector((state) => state.staticData);

  let link = window.location.href;
  let splitUrl = link.split("/");
  splitUrl.splice(4, 1);
  link = splitUrl.join("/");

  const sendInvite = async () => {
    setButton("Sending...")
    let params = {
      organisation_id: organisationIdOfUser,
      to: selectedData?.email,
      trigger: "inviteCustomer",
      recipientName: selectedData?.name,
      link: `${link}/${dashboardConfig?.invite_customer}`,
      // has_link_expiry: organisationInfo?.has_link_expiry,
      hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
    };
    if (selectedData?.mobile_number) {
      let mobile = selectedData?.mobile_number.split("-");
      let smsParams = {
        mobile_number: mobile[1],
        link: `${link}/${dashboardConfig?.invite_customer}`,
        organisation_id: organisationIdOfUser,
        // has_link_expiry: organisationInfo?.has_link_expiry,
        hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
      };
      sendSMSInvite(smsParams);
    }
    let resp = await handleEmailNotification(params);
    if(resp?.status == "success"){
      setInviteToast();
    } else setButton("Submit")
    dispatch(clearSelectedData());
    closeModal();
  };

  const validateAndSubmit = async(action, isRecursive, status_to_update) => {
    let validateFields = [];
    let fieldType = "";
    dashboardConfig?.invite_customer_form?.form_elements.map((item) => {
      if (
        item.type == "group" ||
        item.type == "recursive" ||
        item.type == "questionnaire"
      ) {
        let selectToggleFields = false;
        fieldType = item.type;
        item.input_fields?.map((_item) => {
          if (_item.type == "toggle") {
            selectToggleFields = true;
          }
          if (
            selectToggleFields &&
            _item.hasOwnProperty("show") &&
            IndirectEval(item.show)
          ) {
            validateFields = [...validateFields, _item];
          }
          if (!selectToggleFields) {
            let selectDependentFields = true;
            if (_item.hasOwnProperty("show")) {
              selectDependentFields = IndirectEval(_item.show);
            }
            if (selectDependentFields)
              validateFields = [...validateFields, _item];
          }
        });
      } else {
        let fieldVisiblity = false;
        if (item.hasOwnProperty("show"))
          fieldVisiblity = IndirectEval(item?.show);
        else fieldVisiblity = true;

        if (fieldVisiblity) {
          validateFields = [...validateFields, item];
        }
      }
    });
    let errors;
    errors = await validate(validateFields, selectedData, dispatch, staticData);
    let errKeys = Object.keys(errors);
    if (errKeys?.length === 0) {
      sendInvite();
    } else {
      setFormErr(errors);
      dynamicFormScroll();
    }
  };
 
  const handelOTPChanges = async (name, value) => {
    let payload = {
      otp: value,
      token_id: tokenId[name],
      key: name,
      transaction_id: aadharOTPResponse?.transaction_id,
      refrence_id: aadharOTPResponse?.reference_id,
      organisation_id: org_id,
      aadhaar_number: aadhaar_number,
      fieldName: fieldName,
      workflow_id: (applicantUser?.primary_workflow_id) ? applicantUser?.primary_workflow_id : primaryWorkflowId,
    };
    let resp = await dispatch(verifyOtp(payload)).unwrap().then(
      res => {
        if (res?.status == "success") {
          let result = res?.responseData?.verification_response?.aadhaar_number_xml
             dispatch(
            setVerificationResponse({
              key: fieldName,
              value: result,
            })
          );
          setMessageToast({ type: "success", msg: res?.message });
          setTimeout(() => {
            setMessageToast(null);
            closeModal()
          }, 3000);
          autofill?.forEach((item) => {
            dispatch(
              setSelectedData({
                key: [`${item?.destination_field}`],
                value: result?.[`${item?.source_field}`],
              })
            );
          });
        } else if (res?.status == "Failed") {
          setMessageToast({ type: "error", msg: res?.message });
          setTimeout(() => {
            setMessageToast(null);
          }, 3000);
        }
      })
  };
  


  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err = { ...formErr };
    for (let key in fields) {
      const _field = fields[key];
      if (err[_field] !== undefined) {
        delete err[_field];
      }
    }
    setFormErr(err);
  };
  return (
    <>
      <Modal
        show={showModal}
        onHide={closeModal}
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
        {messageToast?.msg && (
           <Toast message={messageToast?.msg} type={messageToast?.type }  position="top-right" theme="dark" />
         )}
        <Modal.Header closeButton className="pb-0">
          <Modal.Title className="text-theme-primary fw-bold">{model_name?`${model_name}`:"Send Invite"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          {dashboardConfig?.invite_customer_form?.form_elements?.map(
            (item, index) => {
              if (IndirectEval(item?.show)) {
                return (
                  <Fragment key={index}>
                    <Row>
                      <DynamicForm
                        formFields={item}
                        formErr={formErr}
                        setFormErr={setFormErr}
                        selectedData={selectedData}
                        setSelectedData={setSelectedData}
                        clearFieldError={clearFieldError}
                      />
                    </Row>
                  </Fragment>
                );
              }
            }
          )}
          {model_name &&
            <Fragment>
              <Row>
                <OTP label={otp_verification_details?.label} onChange={handelOTPChanges} name={otp_verification_details?.name} otp_length={otp_verification_details?.otp_length} masking_type={otp_verification_details?.masking_type} otp_retries_limit={otp_verification_details?.otp_retries_limit}></OTP>
              </Row>
            </Fragment>
          }
        </Modal.Body>
        {!model_name&&<Modal.Footer>
          <div>
            <ButtonV1
              label={button}
              className="primary_button"
              variant="primary"
              onClick={validateAndSubmit}
              disabled={selectedData?.mobile_number === "-" ? false : (selectedData?.mobile_number ? !(`${selectedData.mobile_number}`.startsWith("+91")) : false)}
            />
          </div>
        </Modal.Footer>}
      </Modal>
    </>
  );
}

export default InviteCustomer;
